import { UIStyleConstants } from "../../Common/UIStyleConstants";

export class FlowConstants {
    static FLOW_EXECUTION_MAIN_THREAD_ID = "trunk";

    static ERROR_MESSAGE_DATA_NAME = "ErrorMessage";
    static ERROR_STACK_DATA_NAME = "ErrorStack";
    static ERROR_STEP_ID = "ErrorStepId";
    static ERROR_STEP_NAME = "ErrorStepName";
    static ERROR_STEP_TYPE = "ErrorStepType";

    static ToolboxId = "Toolbox";
    static DEFAULT_CANDIDATE_SEQ_ID = "DefaultCandidateId";
    static DROPPING_COLOR = UIStyleConstants.BLUE_COLOR;
    static PATH_DROPPING_COLOR = UIStyleConstants.WHITE_COLOR;
    static DEFAULT_RELATION_LINE_COLOR = UIStyleConstants.GRAY_COLOR;
    static DEFAULT_RELATION_LINE_WIDTH = 1;

    static DEFAULT_SEQUENCE_COLOR = UIStyleConstants.YELLOW_LIGHT_COLOR;
    static DEFAULT_PRIMARY_SEQUENCE_COLOR = UIStyleConstants.BLUE_VERY_LIGHT_COLOR;
    static DEFAULT_ERROR_SEQUENCE_COLOR = UIStyleConstants.RED_VERY_LIGHT_COLOR;
    static DEFAULT_END_SEQUENCE_COLOR = UIStyleConstants.GREEN_LIGHT_COLOR;

    static SELECTED_STACK_COLOR = UIStyleConstants.BLUE_COLOR;
    static ERROR_STACK_COLOR = UIStyleConstants.RED_COLOR;

    static SELECTED_STEP_COLOR = UIStyleConstants.BLUE_COLOR;
    static ERROR_STEP_COLOR = UIStyleConstants.RED_COLOR;

    /**
     * stack size
     */
    // default
    static DEFAULT_STACK_WIDTH = 256;
    static DEFAULT_STACK_HEIGHT = 100;

    // diagram
    static DEFAULT_DIAGRAM_STACK_HEIGHT = 49;
    static DEFAULT_DIAGRAM_STACK_WIDTH = 125;

    // horizontal
    static DEFAULT_HORIZONTAL_STACK_HEIGHT = 49;
    static DEFAULT_HORIZONTAL_STACK_WIDTH = 80;

    static DEFAULT_COLLAPSED_STACK_HEIGHT = 80;
    static DEFAULT_COLLAPSED_STACK_WIDTH = 120;

    static COLLAPSED_ERROR_STACK_HEIGHT = 39;
    static COLLAPSED_ERROR_STACK_WIDTH = 152;

    /**
     * candidate size
     */
    static PATH_CANDIDATE_SHIFT = 100;
    static PATH_CANDIDATE_WIDTH = 178;
    static PATH_CANDIDATE_HEIGHT = 54;

    static PATH_DRAGGING_CANDIDATE_WIDTH = 100;
    static PATH_DRAGGING_CANDIDATE_HEIGHT = 54;

    // horizontal
    static HORIZONTAL_PATH_CANDIDATE_SHIFT = 50;
    static HORIZONTAL_PATH_CANDIDATE_WIDTH = 118;
    static HORIZONTAL_PATH_CANDIDATE_HEIGHT = 54;

    static SEQUENCE_CANDIDATE_SHIFT = 50;

    static COLLAPSE_TIMEOUT = 300;

    static OVER_SEQUENCE_COLOR = "lightblue";

    static DESIGN_SURFACE_ID = "designsurface";
    static PRIMARY_SEQUENCE: string = "primary__sequence";
    static PRIMARY_SEQUENCE_POSITION: { x: number; y: number } = { x: 20, y: 40 };
    static TITLE_AREA_HEIGHT: number = 18;

    static FLOW_CONNECT_AREA_HEIGHT: number = 40;

    static ERROR_SEQUENCE = "error__sequence";
    static END_SEQUENCE = "end__sequence";

    static SEQUENCE_STRATEGY_Y_OFFSET = 50;
    static SEQUENCE_STRATEGY_X_OFFSET = -10;

    // title colors
    static DEFAULT_TITLE_COLOR = UIStyleConstants.GRAY_COLOR;
    static PRIMARY_TITLE_COLOR = UIStyleConstants.BLUE_COLOR;

    static ERROR_TITLE_COLOR = UIStyleConstants.RED_COLOR;
    static ERROR_COLLAPSED_TITLE_COLOR = "" + UIStyleConstants.GRAY_COLOR;

    static END_TITLE_COLOR = "" + UIStyleConstants.GRAY_COLOR;
    static END_COLLAPSED_TITLE_COLOR = "" + UIStyleConstants.GRAY_COLOR;

    static ERROR_LINE_COLOR = UIStyleConstants.RED_COLOR;
    static END_LINE_COLOR = UIStyleConstants.BLUE_COLOR;

    static SSS_STEP_DROP_OVER_BORDER_COLOR = "green";

    static DRAGGING_STEP_WIDTH = 90;
    static DRAGGING_STEP_HEIGHT = 40;
    static MAX_CHARS_DRAGGING_STEP = 15;

    static MAX_CHARS_STEP_PATH_LABEL = 8;

    static NEXT_STEP_PATH_COLOR = UIStyleConstants.BLUE_COLOR;
    static NEXT_STEP_PATH_TITLE_COLOR = UIStyleConstants.GREEN_COLOR;
    static STEP_PATH_ERROR_COLOR = UIStyleConstants.RED_COLOR;
    static STEP_PATH_END_COLOR = UIStyleConstants.BLUE_COLOR;

    static ITERATION_PATH_NAME = "for each";
}
